// The WebGPU bit flags, named once.
//
// `GPUBufferUsage`, `GPUTextureUsage` and `GPUShaderStage` are VALUES the DOM
// library declares no type for, and a test environment supplies none of them.
// `perf/gputimer-gpu.ts` names the four flags it uses for the same reason.
// This file names the flags the backend uses, so no other module writes a
// bare hexadecimal number.
//
// The numbers are the specification's own and they never change.

/** `GPUBufferUsage.COPY_DST`: the queue writes into the buffer. */
export const BUFFER_COPY_DST = 0x0008;

/** `GPUBufferUsage.INDEX`. */
export const BUFFER_INDEX = 0x0010;

/** `GPUBufferUsage.VERTEX`. */
export const BUFFER_VERTEX = 0x0020;

/** `GPUBufferUsage.UNIFORM`. */
export const BUFFER_UNIFORM = 0x0040;

/** `GPUTextureUsage.COPY_DST`: `writeTexture` and the external-image copy. */
export const TEXTURE_COPY_DST = 0x02;

/** `GPUTextureUsage.TEXTURE_BINDING`: a shader reads it. */
export const TEXTURE_BINDING = 0x04;

/** `GPUTextureUsage.RENDER_ATTACHMENT`: a pass draws into it. */
export const TEXTURE_RENDER_ATTACHMENT = 0x10;

/** `GPUShaderStage.VERTEX`. */
export const STAGE_VERTEX = 0x1;

/** `GPUShaderStage.FRAGMENT`. */
export const STAGE_FRAGMENT = 0x2;
